import { useTable } from 'react-table'

import { Paginate } from '..'

import * as S from './styles'

type TableProps = {
  columns: any
  dataTable: any
  onClick?: any
  handlePageClick?: any
  pageCount?: any
  className?: string
}

const Table = ({
  columns,
  dataTable,
  onClick,
  handlePageClick,
  pageCount,
  className
}: TableProps) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data: dataTable
    })

  return (
    <S.Wrapper className={className}>
      <table {...getTableProps()}>
        <thead>
          {headerGroups?.map((headerGroup) => (
            <tr {...headerGroup?.getHeaderGroupProps()}>
              {headerGroup?.headers?.map((column) => (
                <th {...column?.getHeaderProps()}>
                  {column?.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows?.map((row) => {
            prepareRow(row)
            return (
              <tr {...row?.getRowProps()}>
                {row?.cells?.map((cell) => {
                  return (
                    <td
                      {...cell?.getCellProps()}
                      onClick={() =>
                        typeof cell?.value !== 'object' && onClick(row)
                      }
                    >
                      {cell?.render('Cell')}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      <Paginate handlePageClick={handlePageClick} pageCount={pageCount} />
    </S.Wrapper>
  )
}

export default Table
